export default __webpack_public_path__ + "static/san_chianski_mountain_range_weed_farm-87ca5cc4ffff30e99ec30c083072d7b1.png";